import { render, staticRenderFns } from "./UserChartDetails.vue?vue&type=template&id=4a461d04&"
import script from "./UserChartDetails.vue?vue&type=script&lang=js&"
export * from "./UserChartDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports